import React from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import SpinnerContainer from './components/Utilities/Ui/SpinnerContainer';
import { Route, Routes } from 'react-router-dom';
import OuterLayout from './components/OuterLayout';
import NonWizardLayout from './components/NonWizardLayout';
import Layout from './components/Layout';
import Outline from './components/Outline/Outline';
import CatchmentContext from './components/CatchmentContext/CatchmentContext';
import Enterprises from './components/Enterprises/Enterprises';
import Infrastructure from './components/Infrastructure/Infrastructure';
import InfrastructureMap from './components/Infrastructure/InfrastructureMap';
import InfrastructureRisk from './components/Infrastructure/InfrastructureRisk';
import ExternalOrganisation from './components/ExternalOrganisation/ExternalOrganisation';
import EditExternalOrganisation from './components/ExternalOrganisation/EditExternalOrganisation';
import CreateExternalOrganisation from './components/ExternalOrganisation/CreateExternalOrganisation';
import User from './components/User/User';
import AccessManager from './components/User/AccessManager';
import CreateUser from './components/User/CreateUser';
import EditUser from './components/User/EditUser';
import Farm from './components/Farm/Farm';
import DataImport from './components/Farm/DataImport';
import CreateFarm from './components/Farm/CreateFarm';
import EditFarm from './components/Farm/EditFarm';
import UserFarm from './components/UserFarm/UserFarm';
import UserVineyard from './components/UserFarm/UserVineyard';
import Subscriptions from './components/Subscriptions/Subscriptions';
import ViewSubscription from './components/Subscriptions/ViewSubscription';
import News from './components/News/News';
import CreateNews from './components/News/CreateNews';
import EditNews from './components/News/EditNews';
import Unauthorized from './components/Utilities/Errors/Unauthorized';
import NotFound from './components/Utilities/Errors/NotFound';
import RequireAuth from './components/Utilities/RequireAuth/RequireAuth';
import Login from './components/Utilities/Auth/Login';
import Auth0Login from './components/Utilities/Auth/Auth0Login';
import Auth0Success from './components/Utilities/Auth/Auth0Success';
import Stripe from './components/Utilities/Auth/Stripe';
import Signup from './components/Utilities/Auth/Signup';
import SignupThanks from './components/Utilities/Auth/SignupThanks';
import ResetPassword from './components/Utilities/Auth/ResetPassword';
import ChangePwd from './components/Utilities/Auth/ChangePwd';
import TestAuth from "./components/Utilities/Errors/TestAuth";
import TestAuthOrg from "./components/Utilities/Errors/TestAuthOrg";
import Lmu from './components/Lmu/Lmu';
import ContaminantEvaluation from './components/ContaminantEvaluation/ContaminantEvaluation';
import Ghg from './components/Ghg/Ghg';
import GhgComplete from './components/Ghg/GHGComplete';
import Waterways from './components/Waterways/Waterways';
import WaterwaysMap from './components/Waterways/WaterwaysMap';
import WaterwaysRisk from './components/Waterways/WaterwaysRisk';
import LandSoil from './components/LandSoil/LandSoil';
import Cropping from './components/Cropping/Cropping';
import EffluentDisposal from './components/EffluentDisposal/EffluentDisposal';
import MahingaKai from './components/MahingaKai/MahingaKai';
import FreshWaterIrrigation from './components/FreshWaterIrrigation/FreshWaterIrrigation';
import MyInfo from './components/MyInfo/MyInfo';
import ViewNews from './components/MyInfo/ViewNews';
import FarmSelector from './components/Farm/FarmSelector';
import Biodiversity from './components/Biodiversity/Biodiversity';
import Biosecurity from './components/Biosecurity/Biosecurity';
import Nutrients from './components/Nutrients/Nutrients';
import Summary from './components/Summary/Summary';
import RiskMap from './components/RiskMap/RiskMap';
import Home from "./components/Home";
import WinterGrazing from "./components/WinterGrazing/WinterGrazing";
import LmuUpload from "./components/Uploads/LmuUpload";
import ShapeUpload from "./components/UserKMLUpload/ShapeUpload";
import AllFarmsSummary from './components/AllFarmsSummary/AllFarmsSummary';
import EnterpriseInsights from './components/EnterpriseInsights/EnterpriseInsights';
import './custom.css';
import './common.css';
import useAuth from "./components/Utilities/Hooks/useAuth";
import RiskSummary from './components/RiskMap/RiskSummary';
import ChangePassword from './components/User/ChangePassword';
import Risk from './components/RiskSummary/RiskSummary';
import Welcome from "./components/Welcome";
import toast, { Toaster } from 'react-hot-toast';
import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";
import useLocalStorage from "./components/Utilities/Hooks/useLocalStorage";
import { apiGet, apiPost } from "./components/Utilities/Hooks/apiWrapper";
const ROLES = {
    'Admin': 1,
    'OrgUser': 2,
    'EntityUser': 8,
    'SWNZAdmin': 6,
}

const App = () => {

    return (
        <Auth0Provider
            domain={process.env.REACT_APP_AUTH0_DOMAIN}
            clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
            cacheLocation="localstorage"
            useRefreshTokens={true}
            authorizationParams={{
                redirect_uri: process.env.REACT_APP_AUTH0_REDIRECTURI,
                audience: process.env.REACT_APP_AUTH0_AUDIENCE,
            }}
        >
            <Main />
        </Auth0Provider>
    );
};

function Main() {
    const { isAuthenticated, logout } = useAuth0();
    const [defaultFarmId, setDefaultFarmId] = useLocalStorage('defaultFarmId', '');
    const [defaultFarmName, setDefaultFarmName] = useLocalStorage('defaultFarmName', '');
    const [defaultFarmUniqueId, setDefaultFarmUniqueId] = useLocalStorage('defaultFarmUniqueId', '');
    const [isAddArchiveItem, setIsAddArchiveItem] = useLocalStorage('isAddArchiveItem', '');
    const [isAddEditItem, setIsAddEditItem] = useLocalStorage('isAddEditItem', '');
    const [isCreateNewAction, setIsCreateNewAction] = useLocalStorage('isCreateNewAction', '');
    const [isSubmitEvidenceCloseAction, setIsSubmitEvidenceCloseAction] = useLocalStorage('isSubmitEvidenceCloseAction', '');
    const [isAddDeleteDocument, setIsAddDeleteDocument] = useLocalStorage('isAddDeleteDocument', '');
    const [saveRightsForNonItemFieldsAndTables, setSaveRightsForNonItemFieldsAndTables] = useLocalStorage('saveRightsForNonItemFieldsAndTables', '');
    const [farmRoleName, setFarmRoleName] = useLocalStorage('farmRoleName', null);
    const { isRefreshing } = useState(localStorage.getItem("isRefreshing"));
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [farmId] = useState(localStorage.getItem("defaultFarmId"));
    const [userId] = useState(localStorage.getItem("loggedInUserId"));
    const [wizardDetails, setWizardDetails] = useState([]);
    const [pageReload, setpageReload] = useState(true);
    const { auth, setAuth } = useAuth();

    useEffect(() => {
            //if (auth != null) {
            //    axios.defaults.headers.common['Authorization'] = `Bearer ${auth.token}`;
            //}

            setLoading(true);
            OnPageload();
    }, []);

    const OnPageload = async (e) => {
        try {
            let response = await apiGet(
                '/api/wizard/GetWizardDetails/', {
                params: {
                    farmId: farmId == 'null' ? 0 : farmId
                }
            }
            );
            setLoading(false);
            setWizardDetails(response.data);
            window.wizardDetails = response.data.wizardItemList;
            setpageReload(!pageReload)
            var landingPage = response.data.landingPage;

            response = await apiGet(
                '/api/settings/GetUserById/', {
                params: { Id: userId }
            }

            );
            var user = {};
            if (response.data != null) {
                user = response.data.content.users.filter(x => x.id == userId);
                if (user != null) {
                }
            }
            if (window.location.pathname == '/' || window.location.pathname.toLowerCase() == '/home') {
                if (user != null) {
                    if (!user[0].tcAccepted) {
                        window.open("/welcome", "_self");
                    }
                    else if (user[0].roleText != null && user[0].roleText == 'SWNZ Admin') {
                        window.open('myvineyardsummary', "_self");
                    }
                    else if (user[0].tcAccepted && farmId == '0') {
                        setDefaultFarmId(0);
                        setDefaultFarmName(null);
                        setDefaultFarmUniqueId(null);
                        setIsAddArchiveItem(null);
                        setIsAddEditItem(null);
                        setIsCreateNewAction(null);
                        setIsSubmitEvidenceCloseAction(null);
                        setIsAddDeleteDocument(null);
                        setSaveRightsForNonItemFieldsAndTables(null);
                        setFarmRoleName(null);
                        window.open('myvineyardsummary', "_self");
                        return;
                    }
                    else if (user[0].tcAccepted && user[0].userFarmList.length > 0) {
                        window.open(landingPage, "_self");
                    }
                    else if (user[0].userFarmList.length == 0) {
                        toast.error("Sorry, this user does not have any farm allocated to access. Please contact admin team", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                    }
                }
            }
        } catch (err) {
            console.log(err);
        }
    }

    const handleWizardChanged = async (section) => {
        let form = {
            farmId: farmId,
            section: section,
            userId: userId,
        }
        try {
            const response = await axios.post(
                '/api/wizard/UpdateWizardDetails/',
                JSON.stringify(form), {
                params: {
                    farmId: farmId,
                    section: section,
                    userId: userId
                },
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
            if (response.data != null) {
                if (response.data.status == true) {
                    const redirectURL = response.data.content.redirectURL;
                    const wizardModel = response.data.content.wizardModel;
                    setWizardDetails(wizardModel);
                    setpageReload(!pageReload);
                    window.open(redirectURL, "_self");
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }

    }

    const handleWizardChangedBack = async (section) => {
        let form = {
            farmId: farmId,
            section: section,
            userId: userId,
        }
        try {
            const response = await axios.post(
                '/api/wizard/UpdateWizardDetailsBack/',
                JSON.stringify(form), {
                params: {
                    farmId: farmId,
                    section: section,
                    userId: userId
                },
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
            if (response.data != null) {
                if (response.data.status == true) {
                    const redirectURL = response.data.content.redirectURL;
                    const wizardModel = response.data.content.wizardModel;
                    setWizardDetails(wizardModel);
                    setpageReload(!pageReload);
                    window.open(redirectURL, "_self");
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }

    }

    const handleMoveToNextPage = async (section) => {
        let form = {
            farmId: farmId,
            section: section,
            userId: userId,
        }
        try {
            const response = await axios.post(
                '/api/wizard/MoveToNextPage/',
                JSON.stringify(form), {
                params: {
                    farmId: farmId,
                    section: section,
                    userId: userId
                },
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
            if (response.data != null) {
                if (response.data.status == true) {
                    const redirectURL = response.data.content.redirectURL;
                    setpageReload(!pageReload);
                    window.open(redirectURL, "_self");
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }

    }

    const handleWizardFarmChanged = async (farmid) => {

        try {
            const response = await apiGet(
                '/api/wizard/GetWizardDetails/', {
                params: {
                    farmId: farmid
                }
            }
            );
            if (response.data != null) {
                setWizardDetails(response.data)
                if (response.data.isCompleted) {
                    window.open("/summary", "_self");
                }
                else {
                    window.open(response.data.landingPage, "_self");
                }
            }
        } catch (error) {

            console.error('Error:', error);
        }

    }

    const refreshToken = async () => {
        if (isAuthenticated) {
            if (auth != null) {
                let form = {
                    Token: localStorage.getItem("accessToken"),
                    UserId: auth.loggedInUserId,
                    UserName: auth.username,
                    Email: auth.email,
                    Role: auth.role
                }
                const response = await axios.post(
                    '/api/Token/RefreshToken/', JSON.stringify(form),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    });
                if (!response.data.isTokenValid) {
                    localStorage.clear();
                    logout({ returnTo: window.location.origin })
                }
                else {
                }
            }
            else {
                localStorage.clear();
                logout({ returnTo: window.location.origin })
            }
        }
        else {
            localStorage.clear();
            logout({ returnTo: window.location.origin })
        }
    }

    const clearSessionitems = async () => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('auth');
        localStorage.removeItem('defaultFarmId');
        localStorage.removeItem('defaultFarmName');
        localStorage.removeItem('defaultFarmUniqueId');
        localStorage.removeItem('farmRoleName');
        localStorage.removeItem('isAddArchiveItem');
        localStorage.removeItem('isAddDeleteDocument');
        localStorage.removeItem('isAddEditItem');
        localStorage.removeItem('isCreateNewAction');
        localStorage.removeItem('isSubmitEvidenceCloseAction');
        localStorage.removeItem('isSuperAdmin');
        localStorage.removeItem('loggedInUserId');
        localStorage.removeItem('roleName');
        localStorage.removeItem('saveRightsForNonItemFieldsAndTables');
    }

    return (
        <div>
            {loading
                ? <SpinnerContainer />
                :
                <div>
                    <Routes>
                        <Route exact path="/" element={<OuterLayout />}>
                            <Route path="/login" element={<Auth0Login />} />
                            <Route path="/auth0login" element={<Auth0Login />} />
                            <Route path="/auth0success" element={<Auth0Success />} />
                            <Route path="/signup" element={<Signup />} />
                            <Route path="/stripe" element={<Stripe />} />
                            <Route path="/signupthanks" element={<SignupThanks />} />
                            <Route path="/resetpassword" element={<ResetPassword />} />
                            <Route path="/changepwd" element={<ChangePwd />} />
                            <Route path="/notfound" element={<NotFound />} />
                            <Route element={<Layout clearSessionitems={clearSessionitems} logout={logout} refreshToken={refreshToken} wizardDetails={wizardDetails} pageReload={pageReload} />}>
                                
                                <Route element={<RequireAuth allowedRoles={[ROLES.Admin]} />}>
                                    <Route path="/testauth" element={<TestAuth />} />
                                </Route>
                                <Route element={<RequireAuth allowedRoles={[ROLES.OrgUser]} />}>
                                    <Route path="/testauthorg" element={<TestAuthOrg />} />
                                </Route>
                                <Route element={<RequireAuth allowedRoles={[ROLES.Admin, ROLES.EntityUser, ROLES.OrgUser, ROLES.SWNZAdmin]} />}>
                                    <Route path="/" element={<Welcome refreshToken={refreshToken} handleWizardFarmChanged={handleWizardFarmChanged} />} />
                                    <Route path="/outline" element={<Outline refreshToken={refreshToken} handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/catchmentcontext" element={<CatchmentContext refreshToken={refreshToken} handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/enterprises" element={<Enterprises refreshToken={refreshToken} handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/myvineyardsummary" element={<EnterpriseInsights name="My Vineyards" refreshToken={refreshToken} handleWizardFarmChanged={handleWizardFarmChanged} />} />
                                    {/*<Route path="/infrastructure" element={<Infrastructure handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />*/}
                                    <Route path="/infrastructuremap" element={<InfrastructureMap refreshToken={refreshToken} handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/infrastructurerisk" element={<InfrastructureRisk refreshToken={refreshToken} handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    {/* <Route path="/waterways" element={<Waterways handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />*/}
                                    <Route path="/waterwaysmap" element={<WaterwaysMap refreshToken={refreshToken} handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/waterwaysrisk" element={<WaterwaysRisk refreshToken={refreshToken} handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/landsoil" element={<LandSoil refreshToken={refreshToken} handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/effluentdisposal" element={<EffluentDisposal refreshToken={refreshToken} handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/freshwaterirrigation" element={<FreshWaterIrrigation refreshToken={refreshToken} handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/biodiversity" element={<Biodiversity refreshToken={refreshToken} handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/biosecurity" element={<Biosecurity refreshToken={refreshToken} handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/mahingakai" element={<MahingaKai refreshToken={refreshToken} handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/lmu" element={<Lmu refreshToken={refreshToken} handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/contaminantevaluation" element={<ContaminantEvaluation refreshToken={refreshToken} handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/cropping" element={<Cropping refreshToken={refreshToken} handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/ghg" element={<Ghg refreshToken={refreshToken} handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/ghgcomplete" element={<GhgComplete refreshToken={refreshToken} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/nutrients" element={<Nutrients refreshToken={refreshToken} handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/wintergrazing" element={<WinterGrazing refreshToken={refreshToken} handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/summary" element={<Summary refreshToken={refreshToken} handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/riskmap" element={<RiskMap refreshToken={refreshToken} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/risksummary" element={<RiskSummary refreshToken={refreshToken} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />
                                    <Route path="/risk" element={<Risk refreshToken={refreshToken} handleMoveToNextPage={handleMoveToNextPage} handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} />} />

                                </Route>
                            </Route>
                            <Route element={<NonWizardLayout clearSessionitems={clearSessionitems} logout={logout} refreshToken={refreshToken} />}>
                                <Route element={<RequireAuth allowedRoles={[ROLES.Admin, ROLES.EntityUser, ROLES.OrgUser, ROLES.SWNZAdmin]} />}>
                                    <Route path="/unauthorized" element={<Unauthorized />} />
                                    <Route path="/Welcome" element={<Welcome refreshToken={refreshToken} handleWizardFarmChanged={handleWizardFarmChanged} />} />
                                    <Route path="/farmselector" element={<FarmSelector refreshToken={refreshToken} handleWizardFarmChanged={handleWizardFarmChanged} />} />
                                    <Route path="/allfarmssummary" element={<AllFarmsSummary refreshToken={refreshToken} handleWizardFarmChanged={handleWizardFarmChanged} />} />
                                    <Route path="/allvineyardsummary" element={<EnterpriseInsights name="My Vineyards" refreshToken={refreshToken} handleWizardFarmChanged={handleWizardFarmChanged} />} />
                                </Route>
                                <Route path="/home" element={<Welcome refreshToken={refreshToken} handleWizardFarmChanged={handleWizardFarmChanged} />} />
                                <Route path="/externalorganisation" element={<ExternalOrganisation refreshToken={refreshToken} />} />
                                <Route path="/editexternalorganisation" element={<EditExternalOrganisation refreshToken={refreshToken} />} />
                                <Route path="/createexternalorganisation" element={<CreateExternalOrganisation refreshToken={refreshToken} />} />
                                <Route path="/user" element={<User refreshToken={refreshToken} />} />
                                <Route path="/accessmanager" element={<AccessManager refreshToken={refreshToken} />} />
                                <Route path="/createuser" element={<CreateUser refreshToken={refreshToken} />} />
                                <Route path="/edituser" element={<EditUser refreshToken={refreshToken} />} />
                                <Route path="/farm" element={<Farm refreshToken={refreshToken} />} />
                                <Route path="/import" element={<DataImport refreshToken={refreshToken} />} />
                                <Route path="/createfarm" element={<CreateFarm refreshToken={refreshToken} />} />
                                <Route path="/editfarm" element={<EditFarm refreshToken={refreshToken} />} />
                                <Route path="/news" element={<News />} />
                                <Route path="/subscriptions" element={<Subscriptions />} />
                                <Route path="/viewsubscription" element={<ViewSubscription />} />
                                <Route path="/createnews" element={<CreateNews />} />
                                <Route path="/editnews" element={<EditNews />} />
                                <Route path="/uservineyard" element={<UserVineyard refreshToken={refreshToken} />} />
                                <Route path="/myinfo" element={<MyInfo />} />
                                <Route path="/viewnews" element={<ViewNews />} />
                                <Route path="/lmuupload" element={<LmuUpload refreshToken={refreshToken} />} />
                                <Route path="/shapeUpload" element={<ShapeUpload refreshToken={refreshToken} />} />
                                <Route path="/changepassword" element={<ChangePassword />} />
                            </Route>
                        </Route>
                    </Routes>
                </div>
            }
        </div>
    );
}

export default App;